'use strict';
import { Redirect } from 'react-router-dom';
import React, { Component } from 'react';

//importación de componentes
import PanelNovedad from '../../../Common/Components/PanelNovedad';
import Localizacion from './Localizacion';
import ModalHistorialModificaciones from '../../DatosCuenta/HistorialModificacionCuenta/ModalHistorialModificaciones';

import NovedadesHelper from '../../../Common/Helpers/NovedadesHelper';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';


class Cliente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            muestraNombre: true,
            muestraBotonHistorialNombre: false
        }
        this.handleMuestraNombre = this.handleMuestraNombre.bind(this)
    }

    componentDidMount() {
        this.props.actions.getScreenData(this.props.tarjetas.Cliente);
    }

    componentWillUnmount() {
        this.props.actions.limpiarStoreComponente(null, null)
    }

    handleMuestraNombre(valor) {
        if (this.state.muestraNombre != valor) {
            this.setState({ muestraNombre: valor })
        }
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data.novedades && nextProps.data.novedades.length > 0) {
            if (nextProps.data.novedades.length > 0 && nextProps.data.novedades.some(nov => (nov.NovedadCampoCodigo == "NOMBRE_CLIE" && (nov.NovedadEstadoId < 3 || nov.NovedadEstadoId > 20)) || (nov.NovedadCampoCodigo == "APELLIDO_CLIE" && (nov.NovedadEstadoId < 3 || nov.NovedadEstadoId > 20)))) {
                this.handleMuestraNombre(false)
            }
            if (nextProps.data.novedades.length > 0 && nextProps.data.novedades.some(nov => (nov.NovedadCampoCodigo == "NOMBRE_CLIE" && (nov.NovedadEstadoId > 3 || nov.NovedadEstadoId < 20)) || (nov.NovedadCampoCodigo == "APELLIDO_CLIE" && (nov.NovedadEstadoId > 3 || nov.NovedadEstadoId < 20)))) {
                if (!this.state.muestraBotonHistorialNombre) {
                    this.setState({ muestraBotonHistorialNombre: true })
                }
            }
        }
    }

    render() {
        const { data, actions, tarjetas } = this.props;
        const { novedades } = data;
        const { Cliente } = this.props.tarjetas;

        /*PERMISOS*/
        const permisos = tarjetas.claims ? tarjetas.claims.GESTIONCLIENTES : [];
        const permisoModificacionFiliatorios = permisos ? permisos.some(p => p.Codigo_Funcion == "Mfiliatorios") : undefined;
        const permisoConfirmacionFiliatorios = permisos ? permisos.some(p => p.Codigo_Funcion == "Cfiliatorios") : undefined;
        const permisoAltaLocalizacion = true;// permisos.some(p=>p.Codigo_Funcion == "Alocalizacion");
        const permisoBajaLocalizacion = permisos ? permisos.some(p => p.Codigo_Funcion == "Blocalizacion") : undefined;
        const permisoModificacionLocalizacion = permisos ? permisos.some(p => p.Codigo_Funcion == "Mlocalizacion") : undefined;
        /*FIN PERMISOS*/

        let formasComunicacion = data ? data.arregloLocalizacionContacto : [];
        let domicilios = data && data.domiciliosTotal ? data.domiciliosTotal : [];

        let fechaNacimiento = Cliente.FechaNacimiento ? new Date(Cliente.FechaNacimiento) : null;
        if (fechaNacimiento) fechaNacimiento = fechaNacimiento.toLocaleDateString();

        let iconoTipoModificacion = data.parametroGeneral && data.parametroGeneral.SINOCONFIRMACIONMODIFCLIENTE ? "icono-modif-pendiente" : "icono-modif-inmediato";
        let textoTooltip = data.parametroGeneral && data.parametroGeneral.SINOCONFIRMACIONMODIFCLIENTE ? "Algunas modificaciones requieren confirmación para ser ejecutadas." : "Modificaciones inmediatas.";

        const modalModificaciones = <ModalHistorialModificaciones seccion={"datosCuentaGenerales"} listaModificaciones={data.modificacionesCliente} openModal={actions.getLogModificaciones} />

        let iconoTipoPersona = Cliente.FisicaJuridica == "J" ? <div className="iconoPersonaJuridicaDiv"><div className="iconoPersonaJuridicaImg" ></div></div> : <span className="icon-ti-user-icon-persona-gris iconoPersonaCliente"></span>
        let documento = "", cuit = "",  codigo = "", cuitPersonaFisica = "";

        codigo = tarjetas.clienteResultadoBusqueda.TIPO_DOCUMENTO;

        if (Cliente) {
            if (Cliente.NumeroDocumento)
                documento = Cliente.NumeroDocumento.toString();
            else if (Cliente.Documento)
                documento = Cliente.Documento.toString();

            cuit = documento.includes("-") ? documento : cuit + documento.substring(0, 2) + "-" + documento.substring(2, ((documento.length) - 1)) + "-" + documento[documento.length - 1]


            if (Cliente.FisicaJuridica == "F") {
                cuitPersonaFisica = Cliente.Cuit.toString();
                if (cuitPersonaFisica && cuitPersonaFisica != '')
                    cuit = cuitPersonaFisica.includes("-") ? cuitPersonaFisica : cuitPersonaFisica.substring(0, 2) + "-" + cuitPersonaFisica.substring(2, ((cuitPersonaFisica.length) - 1)) + "-" + cuitPersonaFisica[cuitPersonaFisica.length - 1];
                else
                    cuit = documento;
            }
        }

        return (
            <div>
                <div>
                    <div className="separadorGris bottom-padding-xs">
                        <div className="row">
                            <div className="col-md-12">
                                <h1>
                                    {Cliente.FisicaJuridica == "J" ? Cliente.RazonSocial + " - " + Cliente.Id : Cliente.Nombre + " " + Cliente.Apellido + " - " + Cliente.Id}
                                </h1>
                            </div>
                        </div>
                    </div>

                    <div className="separadorGris bottom-padding-xxs topSeparator-xxs">
                        {iconoTipoPersona}&nbsp;  {Cliente.FisicaJuridica == "J" ? "CUIT " + cuit : codigo + " " + (Cliente.NumeroDocumento ? Cliente.NumeroDocumento : Cliente.Documento)}
                        <div data-toggle="tooltip" key={"icon-modif " + (data.parametroGeneral && data.parametroGeneral.SINOCONFIRMACIONMODIFCLIENTE ? "1" : "2")} data-title={textoTooltip} data-placement="left" className={iconoTipoModificacion + " item-pull-right"}></div>
                    </div>

                    <div className='firaSansExtraLightTitulo bottom-separator-xs topSeparator-xxs'>
                        Datos Generales
                    </div>

                    <div >
                        <label className="label-primary">Tipo de cliente</label>
                        <div className="form-group bottom-separator-xs">
                            <div className="campoCliente edit-panel-lapiz-new">
                                {iconoTipoPersona}&nbsp;  {Cliente.FisicaJuridica == 'F' ? "Persona Física" : "Persona Jurídica"}
                            </div>
                        </div>
                    </div>

                    {this.state.muestraNombre && <div >
                        <label className="label-primary">{Cliente.FisicaJuridica == "J" ? "Razón Social" : "Nombre"}</label>
                        <div className="form-group bottom-separator-xs">
                            <div className="camposEdicionCuenta edit-panel-lapiz-new ">
                                {permisoModificacionFiliatorios ? <div className=" clickable camposEdicionCuenta edit-panel-lapiz-child color-azul-claro blackText" onClick={() => this.handleMuestraNombre(false)}>{Cliente.FisicaJuridica == "J" ? Cliente.RazonSocial : Cliente.Nombre + " " + Cliente.Apellido}</div> :
                                    <div className=" camposEdicionCuenta blackText">{Cliente.FisicaJuridica == "J" ? Cliente.RazonSocial : Cliente.Nombre + " " + Cliente.Apellido}</div>}
                                {this.state.muestraBotonHistorialNombre && <div onClick={() => actions.getLogModificacionesNombreCompleto()} className="edit-panel-icono-historial icon-icono-modificaciones"></div>}
                                {data.viendoModificacionesCampo == "NOMBRE_COMPLETO" && <ModalHistorialModificaciones seccion={"datosCuentaGenerales"} listaModificaciones={data.modificacionesCliente} openModal={actions.getLogModificaciones} />}
                            </div>
                        </div>
                    </div>
                    }

                    {!this.state.muestraNombre && <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"NOMBRE_CLIE"}
                        data={data}
                        tituloCampo={"Nombre"}
                        valorActualDescripcion={data.Nombre}
                        valorActual={data.Nombre}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "NOMBRE_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={null/* es campo con input, no lleva opciones*/}
                        codigoCampo={"NOMBRE_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "NOMBRE_CLIE"}
                        seccion={"Cliente"}
                        esInput={true}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "NOMBRE_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "NOMBRE_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />}

                    {!this.state.muestraNombre && <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"APELLIDO_CLIE"}
                        data={data}
                        tituloCampo={"Apellido"}
                        valorActualDescripcion={data.Apellido}
                        valorActual={data.Apellido}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "APELLIDO_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={null/* es campo con input, no lleva opciones*/}
                        codigoCampo={"APELLIDO_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "APELLIDO_CLIE"}
                        seccion={"Cliente"}
                        esInput={true}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "APELLIDO_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "APELLIDO_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />}

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"CUIT_CLIE"}
                        data={data}
                        tituloCampo={"Cuit"}
                        valorActualDescripcion={cuit}
                        valorActual={data.Cuit}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "CUIT_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={null}
                        codigoCampo={"CUIT_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "CUIT_CLIE"}
                        seccion={"Cliente"}
                        esInput={true}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "CUIT_CLIE")}
                        maxLengthInput={11}
                        patternInput={/^[0-9]*$/}
                        errorValidacion={data.errorValidacionNovedad["CUIT_CLIE"] ? data.errorValidacionNovedad["CUIT_CLIE"] : null}
                        funcionValidar={actions.errorValidacionGuardado}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "CUIT_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"TIPODOCUM_CLIE"}
                        data={data}
                        tituloCampo={"Tipo de documento"}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.TIPO_DOCUMENTO_OPCIONES, data.DocumentoTipo)}
                        valorActual={data.DocumentoTipo}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "TIPODOCUM_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={data.TIPO_DOCUMENTO_OPCIONES}
                        codigoCampo={"TIPODOCUM_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "TIPODOCUM_CLIE"}
                        seccion={"Cliente"}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "TIPODOCUM_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "TIPODOCUM_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"NRODOCUM_CLIE"}
                        data={data}
                        tituloCampo={"Número de Documento"}
                        valorActualDescripcion={Cliente.FisicaJuridica == "J" ? cuit : data.DocumentoNumero}
                        valorActual={data.DocumentoNumero}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "NRODOCUM_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={null}
                        codigoCampo={"NRODOCUM_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "NRODOCUM_CLIE"}
                        seccion={"Cliente"}
                        esInput={true}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "NRODOCUM_CLIE")}
                        maxLengthInput={8}
                        patternInput={/^[0-9]*$/}
                        errorValidacion={data.errorValidacionNovedad["NRODOCUM_CLIE"] ? data.errorValidacionNovedad["NRODOCUM_CLIE"] : null}
                        funcionValidar={actions.errorValidacionGuardado}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "NRODOCUM_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"SEXO_CLIE"}
                        data={data}
                        tituloCampo={"Sexo"}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.SEXO_OPCIONES, Cliente.FisicaJuridica == "J" ? null : data.Sexo)}
                        valorActual={data.Sexo}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "SEXO_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={data.SEXO_OPCIONES}
                        codigoCampo={"SEXO_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "SEXO_CLIE"}
                        seccion={"Cliente"}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "SEXO_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "SEXO_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"FNACIM_CLIE"}
                        data={data}
                        tituloCampo={"Fecha de Nacimiento"}
                        valorActualDescripcion={Cliente.FisicaJuridica == "F" && data.FechaNacimiento ? GlobalHelper.CheckDateType(data.FechaNacimiento, true, true) : ""}
                        valorActual={data.FechaNacimiento ? GlobalHelper.CheckDateType(data.FechaNacimiento, true, true) : ""}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "FNACIM_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={null}
                        codigoCampo={"FNACIM_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "FNACIM_CLIE"}
                        seccion={"Cliente"}
                        esInput={true}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "FNACIM_CLIE")}
                        errorValidacion={data.errorValidacionNovedad["FNACIM_CLIE"] ? data.errorValidacionNovedad["FNACIM_CLIE"] : null}
                        funcionValidar={actions.errorValidacionGuardado}
                        patternInput={/^[0-9\/]*$/}
                        maxLengthInput={10}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "FNACIM_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"NACION_CLIE"}
                        data={data}
                        tituloCampo={"Nacionalidad"}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.NACIONALIDAD_OPCIONES, Cliente.FisicaJuridica == "J" ? null : data.Nacionalidad)}
                        valorActual={data.Nacionalidad}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "NACION_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={data.NACIONALIDAD_OPCIONES}
                        codigoCampo={"NACION_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "NACION_CLIE"}
                        seccion={"Cliente"}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "NACION_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "NACION_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"EDOCIVIL_CLIE"}
                        data={data}
                        tituloCampo={"Estado Civil"}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.ESTADO_CIVIL_OPCIONES, Cliente.FisicaJuridica == "J" ? null : data.EstadoCivil)}
                        valorActual={data.EstadoCivil}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "EDOCIVIL_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={data.ESTADO_CIVIL_OPCIONES}
                        codigoCampo={"EDOCIVIL_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "EDOCIVIL_CLIE"}
                        seccion={"Cliente"}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "EDOCIVIL_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "EDOCIVIL_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"CONDIVA_CLIE"}
                        data={data}
                        tituloCampo={"Condición ante el IVA"}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.CATEGORIA_IVA_OPCIONES, data.CategoriaIva)}
                        valorActual={data.CategoriaIva}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "CONDIVA_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={data.CATEGORIA_IVA_OPCIONES}
                        codigoCampo={"CONDIVA_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "CONDIVA_CLIE"}
                        seccion={"Cliente"}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "CONDIVA_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "CONDIVA_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <PanelNovedad
                        aceptarCambios={actions.aceptarCambios}
                        nombreCampo={"ACTIV_CLIE"}
                        data={data}
                        tituloCampo={"Estado de Actividad"}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.OCUPACION_OPCIONES, data.Ocupacion)}
                        valorActual={data.Ocupacion}
                        novedad={(novedades || []).filter(n => n.NovedadCampoCodigo == "ACTIV_CLIE" && ![3, 5, 6, 7].some(e => e == n.NovedadEstadoId))}
                        opciones={data.OCUPACION_OPCIONES}
                        codigoCampo={"ACTIV_CLIE"}
                        selectCombo={actions.selectValorCampo}
                        funcionEdicion={actions.editandoCampo}
                        guardarNovedad={actions.guardarNovedad}
                        cambiarEstadoNovedad={actions.actualizarNovedadEstado}
                        logHistorialCambios={actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.viendoModificacionesCampo == "ACTIV_CLIE"}
                        seccion={"Cliente"}
                        funcionLimpiarStore={actions.limpiarStoreComponente}
                        claseLabel={"blackText"}
                        muestraBotonHistorial={novedades && novedades.some(n => n.NovedadCampoCodigo == "ACTIV_CLIE")}
                        mostrarSpinner={data.loading_cliente && data.campoNovedadesEnProceso == "ACTIV_CLIE"}
                        permisoModificacion={permisoModificacionFiliatorios}
                        permisoConfirmacion={permisoConfirmacionFiliatorios}
                    />

                    <Localizacion
                        actions={actions}
                        data={data}
                        formasComunicacion={formasComunicacion}
                        domicilios={domicilios}
                        domicilioComponentes={data.domicilioComponentes}
                        seleccionarCombo={actions.seleccionarCombo}
                        permisoModificacion={permisoModificacionLocalizacion}
                        permisoAlta={permisoAltaLocalizacion}
                        permisoBaja={permisoBajaLocalizacion}
                    />
                </div>
            </div>
        );
    }
}

export default Cliente;